import { render, staticRenderFns } from "./LiquidacionesGestorCentralizadoView.vue?vue&type=template&id=d89ecb72&"
import script from "./LiquidacionesGestorCentralizadoView.vue?vue&type=script&lang=js&"
export * from "./LiquidacionesGestorCentralizadoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports